module.exports = __webpack_public_path__ + "img/loginaddbanck.b86bd6e5.png";